
<div *ngIf="title" class="title">
    <h1> {{ title }} </h1>
</div>
<app-input class="search"
           [placeholder]="inputPlaceholder"
           [label]="inputLabel"
           [(ngModel)]="searchQuery"
           (ngModelChange)="onSearchChange($event)">
</app-input>
<ng-container *ngIf="canAdd">
    <app-scroll-list-add-button
        class="add"
        [selected]="isCreateSelected"
        (create)="onCreate()">
    </app-scroll-list-add-button>
</ng-container>
<div class="scroller">
    <ng-container *ngIf="hasItems(); else noItems ">
        <virtual-scroller #scroll
                          [items]="items?.items"
                          (vsEnd)="onEnd($event)">
            <ng-container class="item" *ngFor="let item of scroll.viewPortItems">
                <app-scroll-list-item
                    [leftIcon]="item?.icon"
                    [rightIcon]="item?.rightIcon"
                    [selected]="item?.selected"
                    [description]="item?.description"
                    [title]="item?.title"
                    [subtitle]="item?.subtitle"
                    [item]="item?.item || item"
                    [highlighted]="item?.highlighted"
                    (rightIconClick)="onRightIconClick(item)"
                    (click)="onSelect(item)">
                </app-scroll-list-item>
            </ng-container>
        </virtual-scroller>
    </ng-container>

    <ng-template #noItems>
        <ng-container *ngIf="!isLoading; else loadingAnimation">
            <span class="no-items">{{ 'generic.noItems' | translate }}</span>
        </ng-container>
    </ng-template>

    <ng-template #loadingAnimation>
        <app-loading-spinner class="loader"></app-loading-spinner>
    </ng-template>
</div>
